import React from 'react';

import { PeaceIcon } from 'components/Icon';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const CartTopContent = () => (
  <div className="CartTopContent__top-content">
    <span className="CartTopContent__message">{I18n.localize('cart.returnPolicy')}</span>
    <span className="CartTopContent__icon">
      <PeaceIcon />
    </span>
    <style jsx>
      {`
        .CartTopContent__top-content {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .CartTopContent__message {
          color: ${Theme.get('colors-black')};
          font-size: ${Theme.get('font-size-smaller')};
          font-weight: ${Theme.get('font-weight-normal')};
          letter-spacing: ${Theme.get('letter-spacing-px')};
          line-height: 35px;
        }

        .CartTopContent__icon {
          margin-left: 10px;
        }

        @media ${mediumUp} {
          .CartTopContent__message {
            font-size: ${Theme.get('font-size')};
          }
        }
      `}
    </style>
  </div>
);

export default CartTopContent;
